import React from "react";
import "./index.scss";
import PieChart from "devextreme-react/pie-chart";
import { IMdaePieChartOptions } from "./index";
import { useDispatch } from "react-redux";
import {
  DX_WIDGET_NAMES,
  configureMdaeWidgetOptionUpdaters,
} from "../../mdae-framework";

const MdaePieChart: React.FC<IMdaePieChartOptions> = (props) => {
  const dispatch = useDispatch();
  return (
      <PieChart
        {...props}
        onInitialized={(e) => {
          if (typeof props.onInitialized === "function") props.onInitialized(e);
          configureMdaeWidgetOptionUpdaters(
            props.mdaeDataUpdaterConfig,
            DX_WIDGET_NAMES.DX_PIE_CHART,
            e.component,
            dispatch
          );
        }}
      ></PieChart>
  );
};
export default MdaePieChart;
